import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AlertModule } from 'ngx-bootstrap/alert';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { NavComponent } from './nav/nav.component';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';
import { OrdersComponent } from './orders/orders.component';
import { HomeComponent } from './home/home.component';
import { KaliekiAcs } from 'ng2-kalieki-acs';
import { HttpModule } from '@angular/http';
import { LabOrderBusinessService } from './shared/lab-order-business.service';
import { LabOrderApiService } from './shared/lab-order-api.service';
import { LoginGuardService } from './shared/login-guard.service';
import { TokenManager } from './shared/tokenManager';
import { HttpClientModule } from '@angular/common/http';

import { TopNavComponent } from './top-nav/top-nav.component';
import { FrameManagementComponent } from './frame-management/frame-management.component';
import { InvoiceComponent } from './modify-order/invoice/invoice.component';
import { LensComponent } from './modify-order/lens/lens.component';
import { PrescriptionComponent } from './modify-order/prescription/prescription.component';
import { VieworderComponent } from './vieworder/vieworder.component';
import { PrintPdfComponent } from './print-pdf/print-pdf.component';
import { ModifyOrderComponent } from './modify-order/modify-order.component';
import { BevelComponent } from './modify-order/bevel/bevel.component';
import { LabComponent } from './modify-order/lab/lab.component';
import { LensStyleApiService } from './shared/lens-style.api.service';
import { TintComponent } from './modify-order/tint/tint.component';
import { LabOrderReferenceApiService } from './shared/lab-order-reference-api.service';
import { CoatingComponent } from './modify-order/coating/coating.component';
import { FrameComponent } from './modify-order/frame/frame.component';
import { AdvancedLensComponent } from './modify-order/advanced-lens/advanced-lens.component';
import { SpecialInstructionsComponent } from './modify-order/special-instructions/special-instructions.component';
import { SearchComponent } from './orders/search/search.component';
import { ModalOrderButtonComponent } from './orders/modal/modal.component';
import { SearchCriteriaValidationService } from './shared/searchcriteria-validation.service';
import { LensCatalogApiService } from './shared/lens-catalog-api.service';
import { LensCatalogBusinessService } from './shared/lens-catalog-business.service';
import { LabCodeMapperService } from './lab-code-mapper/lab-code-mapper.service';
import { LensCatalogDataLoadedGuardService } from './shared/lens-catalog-data-loaded-guard.service';
import { LensService } from './modify-order/lens/lens.service';
import { SpinnerService } from './orders/search/spinner.service';
import { ClearMessagesService } from './shared/clear-messages.service';
import { PrintPdfService } from './shared/print-pdf.service';
import { CoatingTypes } from './shared/data/coatingTypes';
import { ConfirmationModalComponent } from './orders/search/confirmation-modal/confirmation-modal.component';
import { PaymentStatementsComponent } from './payment-statements/payment-statements.component';
import { PaymentStatementsService } from './shared/payment-statements.service';
import { DatePipe } from '@angular/common';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    NavComponent,
    FooterComponent,
    OrdersComponent,
    HomeComponent,
    TopNavComponent,
    FrameManagementComponent,
    VieworderComponent,
    PrintPdfComponent,
    ModifyOrderComponent,
    BevelComponent,
    InvoiceComponent,
    LensComponent,
    TintComponent,
    CoatingComponent,
    LabComponent,
    PrescriptionComponent,
    FrameComponent,
    AdvancedLensComponent,
    SpecialInstructionsComponent,
    ModalOrderButtonComponent,
    SearchComponent,
    ConfirmationModalComponent,
    PaymentStatementsComponent,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule.forRoot([
      { path: 'login', component: LoginComponent },
      {
        path: 'orders',
        canActivate: [LoginGuardService],
        component: OrdersComponent,
      },
      {
        path: 'paymentStatements',
        canActivate: [LoginGuardService],
        component: PaymentStatementsComponent,
      },
      { path: 'home', component: HomeComponent },
      { path: 'frameManagement', component: FrameManagementComponent },
      {
        path: 'modify/:labOrderNumber',
        canActivate: [LoginGuardService],
        component: ModifyOrderComponent,
      },
      { path: 'viewOrder/:labOrderNumber', component: VieworderComponent },
      { path: 'print-pdf/:labOrderNumber', component: PrintPdfComponent },
      {
        path: 'modifyOrder/:labOrderNumber',
        canActivate: [LensCatalogDataLoadedGuardService],
        component: ModifyOrderComponent,
      },
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: '**', redirectTo: 'home', pathMatch: 'full' },
    ]),
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
    AlertModule.forRoot(),
    KaliekiAcs.forRoot(),
  ],
  providers: [
    LensStyleApiService,
    LabCodeMapperService,
    LabOrderBusinessService,
    LabOrderApiService,
    LensCatalogApiService,
    LensCatalogBusinessService,
    LabOrderReferenceApiService,
    SearchCriteriaValidationService,
    LoginGuardService,
    LensCatalogDataLoadedGuardService,
    LensService,
    SpinnerService,
    ClearMessagesService,
    PrintPdfService,
    TokenManager,
    CoatingTypes,
    PaymentStatementsService,
    DatePipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/app.module.ts